module.exports = __webpack_public_path__ + "img/star-map-step_5.5e1253c.webp";